import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppSelector } from '@/redux/hooks'
import { UserRole } from '@/constants/room'
import { selectRoomPlayers } from '@/redux/selectors/roomSelector'
import { User } from '@/redux/types/user'

export const useEffectiveUser = (): {
  user: User | null
  isSimulationMode: boolean
  actualUser: User | null
} => {
  const actualUser = useAppSelector((state) => state.user.user)
  const currentRoom = useAppSelector((state) => state.room.currentRoom)
  const roomPlayers = useAppSelector(selectRoomPlayers)
  const [searchParams] = useSearchParams()

  const playerId = searchParams.get('playerId') || undefined
  const simulationParam = searchParams.get('simulation') === 'true'

  const isSimulationMode = useMemo(() => {
    return (
      simulationParam &&
      !!playerId &&
      currentRoom?.is_simulating === true &&
      actualUser?.role === UserRole.Professor
    )
  }, [simulationParam, playerId, currentRoom?.is_simulating, actualUser?.role])

  const effectiveUser = useMemo(() => {
    if (
      isSimulationMode &&
      playerId &&
      roomPlayers &&
      roomPlayers.length > 0 &&
      actualUser
    ) {
      const player = roomPlayers.find(
        (p) =>
          p.gamealias === playerId ||
          String(p.member_id) === String(playerId) ||
          p.member_name === playerId
      )

      if (player && player.member_id) {
        return {
          ...actualUser,
          id: Number(player.member_id),
          email: player.member_email || '',
          name: player.member_name || player.gamealias || '',
          role: UserRole.Student,
          profile_picture:
            player.member_profile_picture || actualUser.profile_picture,
        }
      }
    }
    return actualUser
  }, [isSimulationMode, playerId, roomPlayers, actualUser])

  return { user: effectiveUser, isSimulationMode, actualUser }
}
